
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM12 10c2.383-.008 4.671.893 6.363 2.508.161.153.265.346.306.55.04.204.016.42-.075.618-.093.2-.245.362-.431.47-.188.11-.41.167-.648.154a1.127 1.127 0 0 1-.774-.319 6.837 6.837 0 0 0-4.742-1.892c-1.78 0-3.485.681-4.741 1.891a1.124 1.124 0 0 1-.779.309c-.281 0-.563-.103-.778-.308a1.023 1.023 0 0 1-.317-.737c0-.267.106-.534.316-.737C7.376 10.908 9.64 10.007 12 10Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.998 5c3.74.01 7.326 1.435 9.98 3.97.205.196.322.463.322.742 0 .28-.117.547-.323.743-.208.199-.49.31-.786.307a1.127 1.127 0 0 1-.784-.306C18.085 8.226 15.042 7.11 12 7.11c-3.043 0-6.086 1.116-8.409 3.346-.216.208-.5.312-.784.312-.284 0-.568-.104-.785-.312a1.028 1.028 0 0 1-.321-.743c0-.27.107-.539.32-.743C4.675 6.435 8.26 5.01 11.998 5Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path d=\"M12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17C14 18.1046 13.1046 19 12 19Z\" fill=\"black\"/>\r\n<path d=\"M11.9997 10C14.3825 9.99167 16.6714 10.8931 18.3629 12.5076C18.5243 12.6607 18.6282 12.8537 18.6685 13.0585C18.7086 13.2623 18.6854 13.4775 18.5938 13.6758C18.5012 13.876 18.3487 14.0378 18.1628 14.1468C17.975 14.2569 17.7531 14.313 17.5151 14.3C17.224 14.296 16.946 14.1822 16.7409 13.981C15.4844 12.77 13.7784 12.0888 11.999 12.0888C10.2196 12.0888 8.51359 12.77 7.25767 13.9804C7.04231 14.1862 6.76056 14.2885 6.47913 14.2885C6.19769 14.2885 5.91594 14.1862 5.70143 13.9812C5.49048 13.7772 5.38428 13.5107 5.38428 13.2437C5.38428 12.9768 5.49048 12.7103 5.70049 12.5072C7.37587 10.9081 9.63887 10.0078 11.9997 10Z\" fill=\"black\"/>\r\n<path d=\"M11.9983 5C15.7383 5.00955 19.324 6.43548 21.9773 8.96975C22.1833 9.16618 22.3 9.43336 22.3 9.7125C22.3 9.99164 22.1833 10.2588 21.9773 10.4553C21.7689 10.654 21.4866 10.7641 21.191 10.7625C20.8976 10.7641 20.6153 10.654 20.4074 10.4557C18.0846 8.22559 15.0419 7.1099 11.9988 7.1099C8.95581 7.1099 5.9131 8.22559 3.59021 10.4558C3.37354 10.6641 3.08941 10.7676 2.80559 10.7676C2.52177 10.7676 2.23764 10.6641 2.02097 10.4558C1.80744 10.2506 1.69995 9.98172 1.69995 9.7125C1.69995 9.44328 1.80744 9.17445 2.0205 8.96963C4.67372 6.43548 8.25935 5.00955 11.9983 5Z\" fill=\"black\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi-icon.df81087eac057d9a6e587cf05188539d.svg"),
        {
          React: SvgWifiIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      